var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGeoFence = function SvgGeoFence(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56712 2.33062L15.2722 7.45287L10.8639 10.3686C10.4627 10.634 10.3073 11.1473 10.4938 11.5906L12.4909 16.3357L4.2592 16.3357L1.58068 7.66779L8.56712 2.33062Z",
    fill: "#2E3744",
    stroke: "#2E3744"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.78369,
    cy: 7.61377,
    r: 1.15479,
    fill: "#FAFAFA",
    stroke: "#2E3744"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.20825,
    cy: 16.1187,
    r: 1.15479,
    fill: "#FAFAFA",
    stroke: "#2E3744"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3281,
    cy: 16.1187,
    r: 1.15479,
    fill: "#FAFAFA",
    stroke: "#2E3744"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.481,
    cy: 10.9233,
    r: 1.15479,
    fill: "#FAFAFA",
    stroke: "#2E3744"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9453,
    cy: 7.61377,
    r: 1.15479,
    fill: "#FAFAFA",
    stroke: "#2E3744"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.56714,
    cy: 2.45703,
    r: 1.15479,
    fill: "#FAFAFA",
    stroke: "#2E3744"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGeoFence);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "geo_fence.63582406c3a36e94e689dc37a0488e1b.svg";